import script from "./joinus.vue?vue&type=script&lang=ts&setup=true"
export * from "./joinus.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__